import React from 'react';
import AutocompleteHomologation from '../common/autocompleteHomologation';

const Table = props => (
  <div className="module-table top">
    <table>
      <thead>
        <tr>
          <th className="left">
            {props.language.account.homologationDriver.table.source}
            <div>
              <i className="fas fa-question-circle" />
              <span>{props.language.account.homologationDriver.table.dataSource}</span>
            </div>
          </th>
          <th className="left">
            {props.language.account.homologationDriver.table.code}
            <div>
              <i className="fas fa-question-circle" />
              <span>{props.language.account.homologationDriver.table.codeExternoSemiTrailer}</span>
            </div>
          </th>
          <th className="left">
            {props.language.account.homologationDriver.table.aliasSemiTrailer}
            <div>
              <i className="fas fa-question-circle" />
              <span>{props.language.account.homologationDriver.table.dataSourceSemiTrailer}</span>
            </div>
          </th>
          <th className="left">
            {props.language.account.homologationDriver.table.codeAndNameSemiTrailer}
          </th>
        </tr>
      </thead>
      <tbody>
        {props.datos.map((item, i) => (
          <tr key={`row-${i}`} id={`row-${i}`}>
            <td className="first">
              <span className={'yellow'} />
              <div className="input_checkbox">
                <input
                  onClick={props.handleCheck}
                  data-num={i}
                  type="checkbox"
                  id={`check-${i}`}
                  name={`check-${i}`}
                />
                <label htmlFor={`check-${i}`} />
              </div>
              {item.dataSource}
              <input value={item.id} id={`homologation-id-row-${i}`} type="hidden" />
              <input value={item.dataSource} id={`homologation-datasource-${i}`} type="hidden" />
              <input
                value={item.externalEntityId}
                id={`homologation-externalid-${i}`}
                type="hidden"
              />
            </td>
            <td>{item.externalEntityId}</td>
            <td>{item.entityAlias}</td>
            <td>
              <input id={`homologation-id-${i}`} type="hidden" data-homologation="ok" />
              <div className="box-form">
                <AutocompleteHomologation
                  value={props.language.account.homologationDriver.table.selectSemiTrailer}
                  id={`au-${i}`}
                  correlativo={`${i}`}
                  alias="alias"
                  aliasTwo="code"
                  select="alias"
                  idItem="id"
                  filter={props.datosAccount}
                  handleSubmit={props.handleSubmit}
                  valores={props.datos}
                />
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default Table;



// WEBPACK FOOTER //
// ./source/client/components/homologation_semi_trailer/table.jsx